import React from 'react';
import PropTypes from 'prop-types';

const TickList = (props) => {

	return (
		<div className={`tick-list ${props.reverse ? 'reverse' : ''}`}>
			{props.list.map((item, key) => {
				return (
					<div key={key}>{item}</div>
				);
			})}
		</div>
	);

};

TickList.propTypes = {
	list: PropTypes.array.isRequired,
	reverse: PropTypes.bool
};

TickList.defaultProps = {
	list: [],
	reverse: false
};

export default TickList;


// WEBPACK FOOTER //
// ./resources/assets/js/elements/TickList.js